import React from "react";

export const FanDots = ({ dots = [], height = 150, testid = "fan-dots" }) => {
  const W = 320, H = height;
  const proj = (d) => ({ x: ((d.lon + 180) / 360) * W, y: ((75 - d.lat) / 135) * H });
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ background: "rgba(0,0,0,.35)", borderRadius: "var(--radius)" }} data-testid={testid} role="img" aria-label="Map of where fans are">
      {[...Array(9)].map((_, i) => <line key={`v${i}`} x1={(i + 1) * (W / 10)} y1="0" x2={(i + 1) * (W / 10)} y2={H} stroke="rgba(200,155,60,.08)" />)}
      {[...Array(4)].map((_, i) => <line key={`h${i}`} x1="0" y1={(i + 1) * (H / 5)} x2={W} y2={(i + 1) * (H / 5)} stroke="rgba(200,155,60,.08)" />)}
      {dots.map((d, i) => { const p = proj(d); return <circle key={i} cx={p.x} cy={p.y} r="3" fill="var(--rose)" opacity=".85" />; })}
    </svg>
  );
};
